/**
 * Ponto de partida do site: carrega os estilos e desenha o App em <div id="raiz">.
 * Usado por: index.html.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './estilos.css';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('index.html precisa ter <div id="raiz">');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
